module.exports = __webpack_public_path__ + "img/1679984071864-IMG_20230328_135007.jpg.87cd22e6.webp";